import { PagenatedResponse } from '@models/common';
import { ProductModel, ProductSearchQuery } from '@models/product';
import { UserContent } from '@models/user-contents';
import { apiClient } from '.';

export const searchProducts = async (query?: ProductSearchQuery) => {
  return apiClient.get<PagenatedResponse<ProductModel>>(`/app/v1/products`, {
    params: query,
  });
};

export const getProduct = async (productId: string) => {
  return apiClient.get<ProductModel>(`/app/v1/products/${productId}`);
};

export const getRecommendProducts = async (productId: string) => {
  return apiClient.get<ProductModel[]>(`/app/v1/products/${productId}/recommends`);
};

export const createMyFavorites = async (data: { productId: string; saleType: string }) => {
  const { productId, saleType } = data;
  return apiClient.post(`/app/v1/products/${productId}/favorite`, { saleType });
};

export const deleteMyFavorites = async (productId: string) => {
  return apiClient.delete(`/app/v1/products/${productId}/favorite`);
};

export const getProductOption = async (productId: string, optionName: string) => {
  return apiClient.get<ProductModel>(`/app/v1/products/${productId}`, { params: { optionName } });
};

export const getProductReviews = async (productId: string) => {
  return apiClient.get<PagenatedResponse<UserContent>>(`/app/v1/products/${productId}/reviews`);
};
